import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from 'shared';

export interface CheckoutItem {
  product_id: number;
  name: string;
  unit_price: number;
  quantity: number;
}

export interface CheckoutSessionPayload {
  items: CheckoutItem[];
  shipping_cost: number;
  customer_email: string;
  address_id?: number | null;
}

export interface SessionResult {
  order_id: number;
  status: string;
  total_amount: string;
  payment_status: string;
  payment_method_type: string | null;
  voucher_url: string | null;
}

@Injectable({ providedIn: 'root' })
export class PaymentsService {
  private readonly http = inject(HttpClient);
  private readonly base = inject(API_BASE_URL);

  /**
   * Crea una sesión de Stripe Checkout.
   * @param payload Artículos, costo de envío y email del cliente.
   * @returns URL de la sesión de Stripe.
   */
  createCheckoutSession(payload: CheckoutSessionPayload): Observable<{ url: string; session_id: string }> {
    return this.http.post<{ url: string; session_id: string }>(`${this.base}/payments/checkout-session`, payload, {
      withCredentials: true,
    });
  }

  /**
   * Verifica una sesión de Stripe pagada y retorna el pedido creado.
   * @param sessionId ID de la sesión de Stripe (cs_...).
   * @returns Datos del pedido creado.
   */
  verifySession(sessionId: string): Observable<SessionResult> {
    return this.http.get<SessionResult>(`${this.base}/payments/session/${sessionId}`, {
      withCredentials: true,
    });
  }

  retryPayment(orderId: number): Observable<{ url: string; session_id: string }> {
    return this.http.post<{ url: string; session_id: string }>(
      `${this.base}/payments/retry/${orderId}`,
      {},
      { withCredentials: true }
    );
  }
}
